import { t } from 'i18next';
import { useContext, useMemo } from 'react';

import OrderBySelector, {
  AvailableOrderOption,
} from '~components/OrderBySelector/OrderBySelector';
import useDispatchNumberSortOptions from '~hooks/useDispatchNumberSortOptions';

import { FilesQueryOrdersSort } from '../../constants';
import FilesQueryContext from '../../FilesQueryContext';

const ordersSortOptions: AvailableOrderOption<FilesQueryOrdersSort>[] = [
  {
    value: FilesQueryOrdersSort.DISPATCH_NUMBER_NAME,
    label: t('dispatch.dispatch_v2.orders_sort.dispatch_number'),
  },
  {
    value: FilesQueryOrdersSort.LOAD_AT,
    label: t('dispatch.dispatch_v2.orders_sort.load_at'),
  },
  {
    value: FilesQueryOrdersSort.CREATED_AT,
    label: t('dispatch.dispatch_v2.orders_sort.created_at'),
  },
  {
    value: FilesQueryOrdersSort.COMPANY_LEGAL_NAME,
    label: t('dispatch.dispatch_v2.orders_sort.company_legal_name'),
  },
  {
    value: FilesQueryOrdersSort.ACCOUNT_NAME,
    label: t('dispatch.dispatch_v2.orders_sort.account_name'),
  },
  {
    value: FilesQueryOrdersSort.FRIENDLY_ORDER_ID,
    label: t('dispatch.dispatch_v2.orders_sort.friendly_order_id'),
  },
];

export default function OrderSelectorCTA() {
  const { ordersSort, applyOrdersSort } = useContext(FilesQueryContext);
  const relabelSortOptions = useDispatchNumberSortOptions();
  const sortOptions = useMemo(
    () =>
      relabelSortOptions(ordersSortOptions, FilesQueryOrdersSort.DISPATCH_NUMBER_NAME),
    [relabelSortOptions],
  );

  return (
    <OrderBySelector
      onChange={applyOrdersSort}
      order={ordersSort}
      orderOptions={sortOptions}
    />
  );
}
